import { useQuery } from '@tanstack/react-query'
import { VersionApi } from 'api/VersionApi'
import type { IVersionInfo } from 'utils/interfaces'

const useVersionInfo = () =>
  useQuery<IVersionInfo, Error>({
    queryKey: ['version'],
    queryFn: () => VersionApi.fetchVersion(),
    staleTime: Infinity,
    retry: false,
  })

export default useVersionInfo
